import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface VeldProps {
  label: string
  hint?: string
  labelExtra?: ReactNode
  children: ReactNode
  className?: string
}

export function Veld({ label, hint, labelExtra, children, className }: VeldProps) {
  return (
    <label className={cn('flex min-w-0 flex-col gap-1', className)}>
      <span className="label-caps inline-flex items-center gap-1">
        {label}
        {labelExtra}
      </span>
      {children}
      {hint ? <span className="text-xs text-ink-faint">{hint}</span> : null}
    </label>
  )
}
